export default __webpack_public_path__ + "static/media/part_1.6b13ff68.svg";